import http from '../common/http';
import env from '../envConfig';
import { getHeaderRotasAbertas } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterProgramaSocialPorId = async (id: string) => {
  const url = env.urlApi + `/transacional-api/v1/programas-sociais/${id}`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosBasicosPrincipais = async () => {
  const url = env.urlApi + `/transacional-api/v1/programas-sociais/dados-basicos-principais`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
}

export const obterDadosBasicosSecundarios = async () => {
  const url = env.urlApi + `/transacional-api/v1/programas-sociais/dados-basicos-secundarios`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
}
